import { Box, Button, IconButton, Modal, styled } from "@mui/material";
import React, { useState } from "react";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import CloseIcon from "@mui/icons-material/Close";

interface VideoButtonInterface {
    title: string;
}

const VideoButtonContainer = styled(Box)({
    position: "relative",
    display: "flex",
    justifyContent: "center",
});

const TopSectionButton = styled(Button)({
    position: "relative",
    zIndex: 2,
    cursor: "pointer",
    textTransform: "none",
    display: "flex",
    gap: "10px",
    background: "linear-gradient(90deg,#df5b4f,#72313d)",
    borderRadius: "50px",
    padding: "15px 40px",
    fontWeight: 800,
    color: "#FFF",
    fontSize: "1.6rem",
    transition: "background 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.5s ease-out",
    "&:hover": {
        background: "linear-gradient(45deg, #ffc371, #ff5f6d)",
        boxShadow: "0 0 15px #ffc371",
        transform: "scale(1.05)",
    },
    "&.noRightSpace": {
        transform: "translateX(-55px)",
    },
    "&.small": {
        fontSize: "1rem",
    },
    "&.openDownloadButton": {
        transform: "translateX(-25%)",
        "&.noRightSpace": {
            transform: "translateX(-155px)",
        },
    },
    "@media(max-width: 768px)": {
        fontSize: ".8rem",
        "&.small": {
            margin: "auto"
        },
    }
});

const VideoModalContainer = styled(Box)({
    background: "#020508",
    height: "100vh",
    width: "100vw",
    textAlign: "center",
    "& button": {
        padding: "10px",
        marginLeft: "calc(100% - 45px)"
    },
});

const VideoContentContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "calc(100% - 44px)",
    "& iframe":{
        width: "100%",
        aspectRatio: "16/9",
        maxHeight: "95vh"
    }
});

const VideoButton = ({ title }: VideoButtonInterface): JSX.Element => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    
    const onOpenVideoModal = (): void => {
        setOpenModal(true);
    };
    
    const onCloseVideoModal = (): void => {
        setOpenModal(false);
    };
    
    return (
        <VideoButtonContainer>
            <TopSectionButton onClick={onOpenVideoModal}>
                <VideoLibraryIcon htmlColor={"#FFFFFF"} />
                {title}
            </TopSectionButton>
            <Modal open={openModal} onClose={onCloseVideoModal}>
                <VideoModalContainer>
                    <IconButton onClick={onCloseVideoModal}>
                        <CloseIcon htmlColor={"#FFFFFF"} />
                    </IconButton>
                    <VideoContentContainer>
                        <iframe
                            src="https://www.youtube.com/embed/LzQ3qMGP4_g"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                        >
                        </iframe>
                    </VideoContentContainer>
                </VideoModalContainer>
            </Modal>
        </VideoButtonContainer>
    );
};

export default VideoButton;
